module.exports = __webpack_public_path__ + "img/researching-2.d3fb9a5f.svg";